// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FriendsGridLayout.css or ua-common-styles.css */

.ua-middle-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
    padding: 0;
    min-height: 100vh;
    height: auto;
  }
  
  .ua-top-container {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .ua-bottom-container {
    flex: 1 1;
    overflow-y: auto;
    padding: 10px;
  }
  
  .uag-central-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 30px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  
  @media (max-width: 768px) {
    .uag-central-container {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Group/UGGridLayout.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF","sourcesContent":["/* FriendsGridLayout.css or ua-common-styles.css */\n\n.ua-middle-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow-y: auto;\n    padding: 0;\n    min-height: 100vh;\n    height: auto;\n  }\n  \n  .ua-top-container {\n    background: rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n    border-radius: 15px;\n    padding: 20px;\n    margin-bottom: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .ua-bottom-container {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n  }\n  \n  .uag-central-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 30px;\n    padding: 10px;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n  \n  @media (max-width: 768px) {\n    .uag-central-container {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
